<template>
    <div class="add-review-notification"  :class="`add-review-notification--${messageType}`">
            <button class="close" @click.prevent="hideNotification">
            <svg width="24" height="24">
                <use xlink:href="/sprite.svg#icon-close"></use>
            </svg>
        </button>

        <div class="add-review-notification__text">{{text}}</div>
    </div>
</template>

<script>
export default {
    name: 'add-review-notification',
    props: {
        response: {
            type: [Object, String],
            required: true,
        },
    },
    methods: {
        hideNotification() {
            this.$emit('close');
        },
    },

    computed: {
        text() {
            if (this.messageType === 'success') return 'Спасибо. Ваш отзыв отправлен на модерацию.';
            return this.response.data?.message || 'Ошибка при отправке отзыва';
        },
        messageType() {
            return this.response?.status || 'error';
        },
    },
};
</script>
